ACC.termsandconditions = {
  checkBoxClass: '.ph-termslabel .newTermsCheckbox .ph-checkout-checkbox',
  checkoutPaynowClass: '.ph-checkout_paynow',
  disableClass: 'ph-disable',
  isTermsVisited: false,
  cboxLoadedContentClass: '#cboxLoadedContent',
  termsAgreeClass: '.ph-termsAgree',
  bindTermsAndConditionsLink: function(link) {
    link.click(function() {
      $.colorbox({
        href: $('.ph-getTermsAndConditionsUrl').text(),
        width: '100%',
        maxWidth: 640,
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
        },
        close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });
  },
  termsVisitStatus: function() {
    if (ACC.termsandconditions.isTermsVisited) {
      $(ACC.termsandconditions.checkBoxClass).prop('checked', true);
      $(ACC.termsandconditions.checkoutPaynowClass).removeClass(ACC.termsandconditions.disableClass);
    } else {
      $(ACC.termsandconditions.checkBoxClass).prop('checked', false);
      $(ACC.termsandconditions.checkoutPaynowClass).addClass(ACC.termsandconditions.disableClass);
    }
  },
  checkboxShowHide: function() {
    if (ACC.termsandconditions.isTermsVisited) {
      $(ACC.termsandconditions.checkBoxClass).prop('checked', true);
    } else {
      $(ACC.termsandconditions.checkBoxClass).prop('checked', false);
    }
  },
  newTermsAndConditionsLink: function(link) {
    if (!ACC.termsandconditions.isTermsVisited) {
      $(ACC.termsandconditions.checkoutPaynowClass).addClass(ACC.termsandconditions.disableClass);
    }

    link.find('a').css('pointer-events', 'none');
    link.click(function() {
      ACC.termsandconditions.checkboxShowHide();
      $('html').addClass('ph-overflowy__hide');
      $('.ph-termsMandatButtons').remove();
      $.colorbox({
        href: $('.ph-getTermsAndConditionsUrl').text(),
        width: '100%',
        maxWidth: 640,
        height: '90%',
        onComplete: function() {
          $('#cboxContent').addClass('ph-paymentTermsCheckbox');
          $(ACC.termsandconditions.cboxLoadedContentClass).addClass('ph-cboxLoadedContent');
          $('#cboxLoadedContent .content').addClass('ph-content');
          ACC.common.refreshScreenReaderBuffer();
          ACC.termsandconditions.checkboxFeature();
        },
        close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
        onClosed: function() {
          $('html').removeClass('ph-overflowy__hide');
          ACC.termsandconditions.termsVisitStatus();
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });
  },
  checkboxFeature: function() {
    var currentDisableClass = ACC.termsandconditions.disableClass,
        defaultBottomBarHeight = 60,
        viewingDeviceClass = 'ph-desktopview';

    if (ACC.termsandconditions.isTermsVisited) {
      currentDisableClass = '';
    }

    var popupContentHeight = $(ACC.termsandconditions.cboxLoadedContentClass).innerHeight(),
        divHtmlAgree = '<div class="ph-termsAgree ' + currentDisableClass + '">' + $('.checkoutTermsAgreeLabel').html() + '</div>',
        divHtmlNotAgree = '<div class="ph-termsNotAgree">' + $('.checkoutTermsDontAgreeLabel').html() + '</div>';
    var divHtml = '<div class="ph-termsMandatButtons">' + divHtmlNotAgree + divHtmlAgree + '</div>';

    $('#cboxContent').append(divHtml);

    if ($('.ph-termsMandatButtons').height() > 40) {
      defaultBottomBarHeight = 110;
      viewingDeviceClass = 'ph-mobileview';
    }

    $('#cboxContent').addClass(viewingDeviceClass);
    $(ACC.termsandconditions.cboxLoadedContentClass).css('height', (popupContentHeight - defaultBottomBarHeight) + 'px');
    $('#cboxLoadedContent .content').append('<span class="ph-p-2 scrollIdentifier"></span>');
    $(document).on('click', '.ph-termsNotAgree', function() {
      $.colorbox.close();
      ACC.termsandconditions.isTermsVisited = false;
      ACC.termsandconditions.termsVisitStatus();
    });
    $(document).on('click', ACC.termsandconditions.termsAgreeClass, function() {
      if (!$(document).find(ACC.termsandconditions.termsAgreeClass).hasClass('ph-disable')) {
        $.colorbox.close();
        ACC.termsandconditions.isTermsVisited = true;
        ACC.termsandconditions.termsVisitStatus();
      }
    });

    var box = document.querySelector(ACC.termsandconditions.cboxLoadedContentClass);

    box.addEventListener('scroll', function() {
      var scrollableHeight = box.scrollHeight - box.clientHeight;

      if (box.scrollTop + 100 >= scrollableHeight && !ACC.termsandconditions.isTermsVisited) {
        ACC.termsandconditions.termsVisitStatus();
        $(document).find(ACC.termsandconditions.termsAgreeClass).removeClass('ph-disable');
      }
    });
  },
  initialize: function() {
    if ($('.termsAndConditionToggleEnabled').text() === 'true' && $('.ph-checkout-payment,.ph-page-AnonymousPaymentPage').length > 0) {
      var $newtermsElement = $('.ph-termslabel .newTermsCheckbox label');

      $newtermsElement.find('input[type="checkbox"]').attr('disabled', 'disabled');
      ACC.termsandconditions.newTermsAndConditionsLink($newtermsElement);
      $(document).on('submit', '#placeOrderForm1', function() {
        $newtermsElement.find('input[type="checkbox"]').removeAttr('disabled');
      });
    } else {
      ACC.termsandconditions.bindTermsAndConditionsLink($('.termsAndConditionsLink'));
    }
  }
};

$(document).ready(function() {
  ACC.termsandconditions.initialize();
});
